<template>
  <div class="sidebar">
    <div class="logo">
      <!-- <img v-if="!collapse" src="../../assets/imgs/logo.png" />
      <img v-else class="logo_pic" src="../../assets/imgs/logo@2x.png" /> -->
      <div class="logo_title" v-if="!collapse">
        <img src="../../assets/imgs/atLogo.png" />
        <span>艾特社群</span>
      </div>
    </div>
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
      text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <img :src="bingIcon(item.icon)" />
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">
                  {{ threeItem.title }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index"><img
                  :src="bingIcon(subItem.icon)" />{{ subItem.title }}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <!-- <i :class="item.icon"></i> -->

            <img :src="bingIcon(item.icon)" />
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
     <div class="sidebar_foot">
      <p><a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2021018556号</a></p>
      <p style="font-size: 0.8125rem;"><a href="https://www.atzone.net/" target="_blank">艾特社群(成都)科技有限责任公司</a></p>
      <p>@2022 版权所有</p>
    </div>
  </div>
</template>

<script>
  import bus from "../common/bus";
  export default {
    data() {
      return {
        collapse: false,
        items: [{
            icon: "nav_home",
            index: "dashboard",
            title: "工作台",
          },
          {
            icon: "nav_manage",
            index: "yardManage",
            title: "院落管理",
          },
          {
            icon: "nav_household",
            index: "yardHousehold",
            title: "院落住户",
          },
            {
                index: "organization",
                icon: "nav_questionnaire",
                title: "院落机构",
            },
          {
            icon: "nav_cost",
            index: "3",
            title: "院落费用",
            subs: [{
                index: "costProject",
                icon: "nav_sub_item",
                title: "费用科目",
              },
              {
                index: "budget",
                icon: "nav_sub_budget",
                title: "院落预算",
              },
              {
                index: "costConfiscate",
                icon: "nav_sub_collection",
                title: "费用收缴",
              },
              {
                index: "pay",
                icon: "nav_sub_pay",
                title: "支出费用",
              },
              {
                index: "account",
                icon: "nav_sub_account",
                title: "费用账号",
              },
            ],
          },
          {
            icon: "nav_cost",
            index: "4",
            title: "防疫检测",
            subs: [
            // {
            //     index: "nucleicTest",
            //     icon: "nav_sub_item",
            //     title: "核酸检测",
            // },
            // {
            //     index: "volunteer",
            //     icon: "nav_sub_budget",
            //     title: "防疫志愿者",
            // },
            {
                index: "antiepidemicPeople",
                icon: "antiepidemicPeople",
                title: "防疫志愿者",
            },
            {
              index: "communityReporting",
              icon: "communityReporting",
              title: "社区报备",
            },
            {
              index: "detectionPoint",
              icon: "detectionPoint",
              title: "核酸检测点",
            },
            {
              index: "reportRoommate",
              icon: "reportRoommate",
              title: "报备同住人",
            },
            {
              index: "riskArea",
              icon: "riskArea",
              title: "风险区域",
            },
            {
              index: "epidemicInformation",
              icon: "epidemicInformation",
              title: "疫情资讯",
            },
            //   {
            //     index: "yellowred",
            //     icon: "nav_sub_collection",
            //     title: "黄红码处置",
            //   },
            //   {
            //     index: "point",
            //     icon: "nav_sub_pay",
            //     title: "检测点位",
            //   },
            //   {
            //     index: "post",
            //     icon: "nav_sub_account",
            //     title: "防疫岗位",
            //   },
            //   {
            //     index: "material",
            //     icon: "nav_sub_account",
            //     title: "防疫物资",
            //   }
            ]
          },
          // {
          //   icon: "nav_cost",
          //   index: "5",
          //   title: "数据上报",
          //   subs: [
          //     {
          //       index: "epidemic",
          //       icon: "nav_sub_item",
          //       title: "疫情防控",
          //     },
          //     {
          //       index: "oldReform",
          //       icon: "nav_sub_budget",
          //       title: "老旧小区改造",
          //     }
          //   ]
          // },
          {
            icon: "nav_notice",
            index: "topic",
            title: "社区话题",
          },
          {
            icon: "nav_notice",
            index: "notice",
            title: "消息发布",
          },
          {
            icon: "nav_feedback",
            index: "feedback",
            title: "问题反馈",
          },
          {
            icon: "nav_questionnaire",
            index: "questionnaire",
            title: "问卷调查",
          },
          {
            icon: "nav_questionnaire",
            index: "form",
            title: "新建表单"
          },
          {
            icon: "nav_cost",
            index: "11",
            title: "系统设置",
            subs: [
                {
                    index: "SMSconfiguration",
                    icon: "nav_questionnaire",
                    title: "短信配置",
                },
                {
                    index: "userManagement",
                    icon: "nav_questionnaire",
                    title: "用户管理",
                },
                {
                    index: "logManagement",
                    icon: "nav_sub_item",
                    title: "日志管理",
                }
            ]
          }
        ]
      };
    },
    computed: {
      onRoutes() {
        if (this.$route.meta.isAlive) {
          return this.$route.path.replace("/", "");
        } else {
          return this.$route.path.replace("/", "").split("&").filter(Boolean)[0]
        }

      },
    },
    created() {
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on("collapse", (msg) => {
        this.collapse = msg;
        bus.$emit("collapse-content", msg);
      });
    },
    methods: {
      bingIcon(icon) {
        return require(`@/assets/imgs/${icon}.png`);
      },
    },
  };
</script>

<style scoped>
.logo {
    height: 3.3333vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo img {
    width: 37px;
    height: 37px;
  }
  .logo .logo_title span {
    font-size: 1.2vw;
    color: #97a9f1;
    vertical-align: 11px;
    margin-left: 3px;
  }
  .logo_pic {
    width: 2.6042vw !important;
    height: 2.6042vw !important;
  }

  .sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    overflow-y: scroll;
    background: url(../../assets/imgs/siderbar_bg.png) no-repeat;
    background-size: 100% 100%;
  }

  .sidebar::-webkit-scrollbar {
    width: 0;
  }

  .sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;
  }

  .sidebar>ul {
    height: auto;
    border-right: 0;
  }

  .sidebar_foot {
    width: 195px;
    color: #bdbdbd;
    font-size: 14px;
    text-align: center;
    position: absolute;
    bottom: 10px;
  }

  .sidebar_foot p a {
    text-decoration: none;
    color: #bdbdbd;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/sidebar.vue